import { useEffect, useState } from "react";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import paymentService from "#src/services/payment";
import { useOutletContext } from "react-router-dom";
import { LoadingStateV2 } from "#src/commonV2/LoadingState";
import { BillingConfigCustomer } from "#src/components/workspace/billing/config/Customer";
import { BillingConfigInvoice } from "#src/components/workspace/billing/config/Invoice";

export const BillingConfigTab = () => {
  const { workspaceId } = useOutletContext<{
    workspaceId: string;
  }>();

  // --------------- STATES ---------------

  const [defaultPayment, setDefaultPayment] = useState<Awaited<
    ReturnType<typeof paymentService.retrieveWorkspacePaymentSettings>
  > | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    paymentService
      .retrieveWorkspacePaymentSettings(workspaceId)
      .then((response) => {
        setDefaultPayment(response);
      })
      .catch(apiErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  }, [workspaceId]);

  // --------------- RENDER ---------------

  return (
    <>
      <div className="grid grid-cols-3 gap-5">
        {isLoading ? (
          <LoadingStateV2 />
        ) : (
          <div className="col-span-2 flex flex-col gap-5">
            <BillingConfigCustomer
              workspaceId={workspaceId}
              defaultPayment={defaultPayment}
              setDefaultPayment={setDefaultPayment}
            />
            <BillingConfigInvoice
              workspaceId={workspaceId}
              defaultPayment={defaultPayment}
              setDefaultPayment={setDefaultPayment}
            />
          </div>
        )}
        {/* TODO: card payment */}
      </div>
    </>
  );
};
